import { apiGet } from './apiClient.js';

/** Admin-only audit trail (gateway `GET /api/audit`). Returns `{ items, meta }`. */
export const auditApi = {
  list: (params) => apiGet('/api/audit', params),
};
